import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  CreateFeatureFlagRequest,
  FeatureFlagRecord,
} from "../FeatureFlagRecord";

import { featureFlagQueryKeys } from "./featureFlagQueryKeys";
import * as UseFeatureFlags from "./useFeatureFlags";

export function useCreateFeatureFlag() {
  const { featureFlagService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<FeatureFlagRecord, Error, CreateFeatureFlagRequest>({
    mutationFn: (request) => featureFlagService.create(request),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: featureFlagQueryKeys.states(),
      });
    },
  });
}
